import { createNotificationComponent, INotificationProperties } from '@vfde-brix/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { GLASFASER_SERVICE_NOT_AVAILABLE} from '../constant';

/**
 * Export mountButton
 *
 * @export mountNotification
 */
export const mountNotificationSuccess = (target, title) => {

    const props: INotificationProperties = {
        txtContent: '',
        stdTitle: title,
        optHidden: false,
        optType: 'success',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createNotificationComponent(target, props);
};

/**
 * Export mountButton
 *
 * @export mountNotificationFailed
 */
export const mountNotificationFailed = (target, title) => {

    const props: INotificationProperties = {
        txtContent: '',
        stdTitle: title,
        optHidden: false,
        optType: 'info',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createNotificationComponent(target, props);
};

/**
 * Export mountNotificationServiceNotAvailable
 *
 * @export mountNotificationServiceNotAvailable
 */
export const mountNotificationServiceNotAvailable = (target) => {

    const props: INotificationProperties = {
        txtContent: GLASFASER_SERVICE_NOT_AVAILABLE,
        stdTitle: 'Leider gibt ein technisches Problem',
        optHidden: false,
        optType: 'error',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createNotificationComponent(target, props);
};
